import { SlotInitialValues } from './reducer';

export const calendarActions = {
  SHOW_ADD_MEETING_MODAL: 'SHOW_ADD_MEETING_MODAL',
  HIDE_ADD_MEETING_MODAL: 'HIDE_ADD_MEETING_MODAL',
  SHOW_SYNC_MEETING_MODAL: 'SHOW_SYNC_MEETING_MODAL',
  HIDE_SYNC_MEETING_MODAL: 'HIDE_SYNC_MEETING_MODAL',
  SET_SLOT_INITIAL_VALUES: 'SET_SLOT_INITIAL_VALUES',

  showAddMeetingModal: () => ({
    type: calendarActions.SHOW_ADD_MEETING_MODAL,
  }),
  hideAddMeetingModal: () => ({
    type: calendarActions.HIDE_ADD_MEETING_MODAL,
  }),
  showSyncMeetingModal: () => ({
    type: calendarActions.SHOW_SYNC_MEETING_MODAL,
  }),
  hideSyncMeetingModal: () => ({
    type: calendarActions.HIDE_SYNC_MEETING_MODAL,
  }),
  setSlotInitialValues: (payload: SlotInitialValues) => ({
    type: calendarActions.SET_SLOT_INITIAL_VALUES,
    payload,
  }),
};
